import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { INguonBietToiTypeActionTypes } from "../../action-types/crm-category/IDmNguonBietToiTypeActionTypes";
import { IDmNguonBietToiTypeReducer } from "../../page-state-model/crm-category/IDmNguonBietToiTypeReducer";
const iniState: IDmNguonBietToiTypeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    nguonBietToiTypes: []
}
export const nguonBietToiTypeReducer = (state: IDmNguonBietToiTypeReducer = iniState, action: INguonBietToiTypeActionTypes): IDmNguonBietToiTypeReducer => {
    switch (action.type) {
        case "NGUON_BIET_TOI_TYPE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "NGUON_BIET_TOI_TYPE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nguonBietToiTypes: action.payload
            }
        case "NGUON_BIET_TOI_TYPE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nguonBietToiTypes: []
            }
        case "NGUON_BIET_TOI_TYPE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "NGUON_BIET_TOI_TYPE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "NGUON_BIET_TOI_TYPE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "NGUON_BIET_TOI_TYPE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "NGUON_BIET_TOI_TYPE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "NGUON_BIET_TOI_TYPE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "NGUON_BIET_TOI_TYPE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "NGUON_BIET_TOI_TYPE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}